import React, { useContext } from "react";
import styled from "styled-components";

import globalContext from "../../Hooks/globalContext";

const SidebarContainer = styled.aside`
  display: flex;
  flex-direction: column;
  width: 260px;
  min-height: 100vh;
  flex-shrink: 0;
  background: rgba(15, 23, 42, 0.95);
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
`;

const LogoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3D73AD, #2A5A8F);
  color: white;
  font-weight: 700;
  font-size: 16px;
  flex-shrink: 0;
`;

const LogoText = styled.div``;

const LogoTitle = styled.p`
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin: 0;
  line-height: 1;
`;

const LogoSub = styled.p`
  color: #64748b;
  font-size: 11px;
  margin: 4px 0 0;
`;

const Nav = styled.nav`
  flex: 1;
  padding: 16px 12px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const NavItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: ${props => props.active ? '#5B8FBF' : '#94a3b8'};
  background: ${props => props.active ? 'rgba(61, 115, 173, 0.15)' : 'transparent'};
  border: 1px solid ${props => props.active ? 'rgba(61, 115, 173, 0.25)' : 'transparent'};
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;

  &:hover {
    background: ${props => props.active ? 'rgba(61, 115, 173, 0.15)' : 'rgba(61, 115, 173, 0.08)'};
    color: ${props => props.active ? '#5B8FBF' : '#c0d4e8'};
  }
`;

const BottomSection = styled.div`
  padding: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
`;

const UserCard = styled.div`
  background: rgba(30, 41, 59, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 8px;
`;

const UserName = styled.p`
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const UserEmail = styled.p`
  color: #64748b;
  font-size: 11px;
  margin: 2px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const AdminBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(61, 115, 173, 0.2);
  color: #5B8FBF;
`;

const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #f87171;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;

  &:hover {
    background: rgba(248, 113, 113, 0.1);
  }
`;

const menuItems = [
  { key: "userList", label: "유저 관리" },
  { key: "balance", label: "유저 잔액" },
  { key: "sendLog", label: "전송 로그" },
  { key: "lockupList", label: "락업 로그" },
  { key: "shopList", label: "가맹점 관리" },
  { key: "withdraw", label: "출금 신청" },
  { key: "swapList", label: "스왑 로그" },
  { key: "stakingList", label: "스테이킹" },
  { key: "shopExchange", label: "가맹점 환전" },
  { key: "config", label: "설정" },
];

const AdminSideBar = ({ page, onLogout }) => {
  const { user } = useContext(globalContext);

  return (
    <SidebarContainer>
      <LogoSection>
        <LogoIcon>D</LogoIcon>
        <LogoText>
          <LogoTitle>DP Wallet</LogoTitle>
          <LogoSub>Admin Console</LogoSub>
        </LogoText>
      </LogoSection>

      <Nav>
        {menuItems.map(item => (
          <NavItem
            key={item.key}
            active={page.state === item.key}
            onClick={() => page.setState(item.key)}
          >
            {item.label}
          </NavItem>
        ))}
      </Nav>

      <BottomSection>
        {user.state && (
          <UserCard>
            <UserName>{user.state.name || user.state.email}</UserName>
            <UserEmail>{user.state.email}</UserEmail>
            <AdminBadge>Admin</AdminBadge>
          </UserCard>
        )}
        <LogoutButton onClick={onLogout}>
          로그아웃
        </LogoutButton>
      </BottomSection>
    </SidebarContainer>
  );
};

export default AdminSideBar;
